import { getMomentDate } from "../utils/commonUtils";

export default class Inventory {
  constructor(data = {}) {
    this.setData(data);
  }

  setData(data = {}) {
    this.id = data.id || undefined;
    this.goodReceiptCode = data.goodReceiptCode || undefined;
    this.createdByName = data.createdByName || undefined;
    this.materialCode = data.materialCode || undefined;
    this.materialName = data.materialName || undefined;
    this.supplierId = data.supplierId || undefined;
    this.supplierCode = data.supplierCode || undefined;
    this.supplierName = data.supplierName || undefined;
    this.usedDateFrom = getMomentDate(data.usedDateFrom);
    this.usedDateTo = getMomentDate(data.usedDateTo);
    this.quantity = data.quantity || undefined;
    this.whPlanSales = data.whPlanSales || [];
    this.goodReceiptCode = data.goodReceiptCode || undefined;
    this.createdDate = data.createdDate || undefined;
  }

  export() {
    return {
      createdByName: this.createdByName,
      goodReceiptCode: this.goodReceiptCode,
      id: this.id,
      creator: this.creator,
      materialCode: this.materialCode,
      materialName: this.materialName,
      supplierId: this.supplierId,
      supplierCode: this.supplierCode,
      supplierName: this.supplierName,
      usedDateFrom: this.usedDateFrom,
      usedDateTo: this.usedDateTo,
      quantity: this.quantity,
      whPlanSales: this.whPlanSales,
      createdDate: this.createdDate,
    };
  }
}

